/*
 * Maison Forma – précommande sur rupture de stock
 * Un élément portant data-preorder-days="N" reçoit la date à J+N jours ouvrés
 * (hors samedis, dimanches et jours fériés français), calculée à partir de la date du jour à Paris.
 * - <input data-preorder-days> : valeur enregistrée dans la commande
 * - autre élément : texte affiché
 * La ligne « Livraison estimée le … » (.mf-eta) est remplacée par la ligne de rupture de stock quand la variante est en précommande.
 */
(() => {
  if (window.__mfPreorderDates) return;
  window.__mfPreorderDates = true;

  const MONTHS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  const WEEKDAYS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  const holidayCache = {};
  const dayKey = (d) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;

  // Dimanche de Pâques (algorithme grégorien anonyme)
  function easterSunday(y) {
    const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  }

  // Jours fériés légaux en France métropolitaine
  function holidays(y) {
    if (holidayCache[y]) return holidayCache[y];
    const easter = easterSunday(y);
    const fromEaster = (n) => new Date(easter.getFullYear(), easter.getMonth(), easter.getDate() + n);
    const list = [
      new Date(y, 0, 1), fromEaster(1), new Date(y, 4, 1), new Date(y, 4, 8), fromEaster(39), fromEaster(50),
      new Date(y, 6, 14), new Date(y, 7, 15), new Date(y, 10, 1), new Date(y, 10, 11), new Date(y, 11, 25),
    ];
    holidayCache[y] = new Set(list.map(dayKey));
    return holidayCache[y];
  }

  function isBusinessDay(d) {
    const weekday = d.getDay();
    if (weekday === 0 || weekday === 6) return false;
    return !holidays(d.getFullYear()).has(dayKey(d));
  }

  // Date du jour à Paris (même référence que la ligne « Livraison estimée » de la fiche)
  function todayInParis() {
    try {
      const p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: 'numeric', day: 'numeric' })
        .formatToParts(new Date())
        .forEach((x) => { p[x.type] = x.value; });
      return new Date(+p.year, +p.month - 1, +p.day);
    } catch (e) {
      return new Date();
    }
  }

  // J+N jours ouvrés, le jour de consultation n'est pas compté
  function addBusinessDays(n, from = todayInParis()) {
    const d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    let count = 0;
    while (count < n) {
      d.setDate(d.getDate() + 1);
      if (isBusinessDay(d)) count++;
    }
    return d;
  }

  function formatDate(d, withYear, withWeekday) {
    const day = d.getDate() === 1 ? '1er' : String(d.getDate());
    const weekday = withWeekday ? WEEKDAYS[d.getDay()] + ' ' : '';
    return `${weekday}${day} ${MONTHS[d.getMonth()]}${withYear ? ' ' + d.getFullYear() : ''}`;
  }

  // Remplace la ligne « Livraison estimée le … » par la ligne de rupture de stock quand la variante choisie est en précommande
  function syncEta() {
    const container = document.querySelector('[data-ref="add-to-cart-button-container"]');
    const isPreorder = !!container && container.dataset.preorder === 'true';

    document.querySelectorAll('.mf-eta').forEach((eta) => {
      let line = eta.nextElementSibling && eta.nextElementSibling.classList.contains('mf-eta-preorder') ? eta.nextElementSibling : null;

      if (!isPreorder) {
        if (line) line.remove();
        eta.style.display = '';
        return;
      }

      const days = parseInt(container.dataset.preorderDelayDays, 10);
      const delayText = (container.dataset.preorderDelayText || '').trim();
      let label;
      let strong;
      if (days > 0) {
        const date = addBusinessDays(days);
        label = 'Rupture de stock · livraison au plus tard le ';
        strong = formatDate(date, date.getFullYear() !== todayInParis().getFullYear(), true);
      } else if (delayText) {
        label = 'Rupture de stock · livraison prévue ';
        strong = delayText;
      } else {
        label = 'Rupture de stock · précommande';
        strong = '';
      }

      if (!line) {
        line = eta.cloneNode(true);
        line.className = 'mf-eta-preorder';
        line.removeAttribute('data-jours');
        line.style.margin = '0 0 12px';
        eta.after(line);
      }
      const textEl = line.querySelector('.mf-eta__text');
      if (textEl) {
        textEl.textContent = label;
        if (strong) {
          const b = document.createElement('span');
          b.className = 'mf-eta__date';
          b.textContent = strong;
          textEl.appendChild(b);
        }
      }
      eta.style.display = 'none';
    });
  }

  function apply(root) {
    if (!root || !root.querySelectorAll) return;
    const targets = [];
    if (root.matches && root.matches('[data-preorder-days]')) targets.push(root);
    root.querySelectorAll('[data-preorder-days]').forEach((el) => targets.push(el));

    targets.forEach((el) => {
      const n = parseInt(el.dataset.preorderDays, 10);
      if (!n || n < 1) return;
      const date = addBusinessDays(n);
      const otherYear = date.getFullYear() !== todayInParis().getFullYear();
      if (el.tagName === 'INPUT') {
        el.value = `Livraison au plus tard le ${formatDate(date, true)}`;
      } else {
        const text = `Rupture de stock · livraison au plus tard le ${formatDate(date, otherYear)}`;
        if (el.textContent !== text) el.textContent = text;
      }
    });
  }

  window.MFPreorder = { addBusinessDays, formatDate, isBusinessDay, apply, syncEta };

  const run = () => {
    apply(document);
    syncEta();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Le thème remplace le bouton à chaque changement de variante : on recalcule dès qu'un élément concerné est inséré.
  new MutationObserver((mutations) => {
    let buttonChanged = false;
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches('[data-preorder-days]') || node.querySelector('[data-preorder-days]')) apply(node);
        if (node.matches('[data-ref="add-to-cart-button-container"], .mf-eta') || node.querySelector('[data-ref="add-to-cart-button-container"], .mf-eta')) buttonChanged = true;
      }
    }
    if (buttonChanged) syncEta();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
